export default __webpack_public_path__ + "static/media/businessIcon.5a3d2ece.svg";